import type { DietStatus } from '@/types/Diet'

export const DIET_STATUS_OPTIONS: { label: string; value: DietStatus }[] = [
  { label: 'Szkic', value: 1 },
  { label: 'Gotowy', value: 2 },
  { label: 'Archiwalny', value: 3 },
]

export function getDietStatusLabel(status: DietStatus) {
  return DIET_STATUS_OPTIONS.find(option => option.value === status)?.label ?? 'Gotowy'
}

export function getDietStatusVariant(status: DietStatus): 'draft' | 'ready' | 'archived' {
  if (status === 1) return 'draft'
  if (status === 2) return 'ready'
  return 'archived'
}

export function getDietStatusIcon(status: DietStatus): IconName {
  if (status === 1) return 'edit'
  if (status === 2) return 'check'
  return 'archive'
}
